import { defineStore } from 'pinia'
import { ref } from 'vue'
import { GatshipNotification } from '../utils/GatshipNotification'

export const useNotificationStore = defineStore('notification-store', () => {
  const notifications = ref<GatshipNotification[]>([])

  function newNotification(notification: GatshipNotification) {
    notifications.value.push(notification)
  }

  return {
    notifications,
    newNotification
  }
})
